var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.2426101,3.82839654 C5.7674156,3.48080724 6.36162534,3.22960133 7,3.10001812 L7,1 L9,1 L9,3.10001812 C9.63837466,3.22960133 10.2325844,3.48080724 10.7573899,3.82839654 L12.2426407,2.34314575 L13.6568542,3.75735931 L12.1716035,5.2426101 C12.5191928,5.7674156 12.7703987,6.36162534 12.8999819,7 L15,7 L15,9 L12.8999819,9 C12.7703987,9.63837466 12.5191928,10.2325844 12.1716035,10.7573899 L13.6568542,12.2426407 L12.2426407,13.6568542 L10.7573899,12.1716035 C10.2325844,12.5191928 9.63837466,12.7703987 9,12.8999819 L9,15 L7,15 L7,12.8999819 C6.36162534,12.7703987 5.7674156,12.5191928 5.2426101,12.1716035 L3.75735931,13.6568542 L2.34314575,12.2426407 L3.82839654,10.7573899 C3.48080724,10.2325844 3.22960133,9.63837466 3.10001812,9 L1,9 L1,7 L3.10001812,7 C3.22960133,6.36162534 3.48080724,5.7674156 3.82839654,5.2426101 L2.34314575,3.75735931 L3.75735931,2.34314575 L5.2426101,3.82839654 Z M8,10 C9.1045695,10 10,9.1045695 10,8 C10,6.8954305 9.1045695,6 8,6 C6.8954305,6 6,6.8954305 6,8 C6,9.1045695 6.8954305,10 8,10 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.4e8a9d22aa9f46a2843ad28c74fd8334.svg";
export { ForwardRef as ReactComponent };